import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Calendar, Clock } from 'lucide-react';
import api from '../api/client';
import './StreamRecording.css';

const StreamRecording = () => {
  const { recordingId } = useParams();
  const [recording, setRecording] = useState(null);
  const [loading, setLoading] = useState(true);
  const [playing, setPlaying] = useState(false);
  const videoRef = React.useRef(null);

  useEffect(() => {
    loadRecording();
  }, [recordingId]);

  const loadRecording = async () => {
    try {
      setLoading(true);
      const response = await api.recordings.getById(recordingId);
      setRecording(response.data);
    } catch (error) {
      console.error('Error loading recording:', error);
    } finally {
      setLoading(false);
    }
  };

  const formatDuration = (seconds) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    
    if (hours > 0) {
      return `${hours}:${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
    }
    return `${minutes}:${secs.toString().padStart(2, '0')}`;
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-AU', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  };

  if (loading) {
    return <div className="recording-loading">Loading recording...</div>;
  }

  if (!recording) {
    return <div className="recording-error">Recording not found</div>;
  }

  return (
    <div className="recording-page">
      <div className="recording-container">
        <div className="recording-header">
          <Link to="/events" className="recording-back-link">← Back to Events</Link>
          <h1>{recording.title}</h1>
          {recording.description && <p className="recording-description">{recording.description}</p>}
        </div>

        <div className="recording-player-section">
          <div className="recording-player">
            <video
              ref={videoRef}
              src={recording.videoUrl}
              controls
              autoPlay={false}
              className="recording-video"
              onPlay={() => setPlaying(true)}
              onPause={() => setPlaying(false)}
              preload="metadata"
            >
              Your browser does not support the video tag.
            </video>
          </div>

          <div className="recording-info">
            <div className="recording-meta">
              <div className="recording-meta-item">
                <Calendar size={18} />
                <span>Recorded: {formatDate(recording.recordedAt)}</span>
              </div>
              <div className="recording-meta-item">
                <Clock size={18} />
                <span>Duration: {formatDuration(recording.duration)}</span>
              </div>
            </div>

            {recording.stream && (
              <div className="recording-stream-info">
                <h3>Original Stream</h3>
                <p>{recording.stream.title}</p>
                {recording.stream.startedAt && (
                  <p className="recording-date">
                    Streamed: {formatDate(recording.stream.startedAt)}
                  </p>
                )}
              </div>
            )}

            {recording.event && (
              <div className="recording-event-info">
                <h3>Event</h3>
                <p>{recording.event.name || 'Event'}</p>
                {recording.event.date && (
                  <p className="recording-date">
                    Event Date: {formatDate(recording.event.date)}
                  </p>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default StreamRecording;

